<div data-test-id="filterable-hotel-list">
	@for (blok of carouselInputs(); track $index) {
		@if (carouselComponents) {
			<ndc-dynamic
				[ndcDynamicComponent]="carouselComponents[blok['component']]"
				[ndcDynamicInputs]="blok"
			/>
		}
	}
	<section class="bg-white section-spacing">
		<div class="section-inner section-gap flex-col">
			<div class="column-gap flex-col lg:flex-row">
				<div
					class="hidden flex-col lg:flex lg:w-1/4 lg:max-w-1/4 lg:min-w-1/4 lg:flex-none lg:basis-1/4"
					data-test-id="desktop"
				>
					<ng-container [ngTemplateOutlet]="filtersTpl" />
				</div>
				<div
					class="flex flex-col lg:min-w-0 lg:flex-1"
					data-test-id="content"
				>
					@for (blok of title(); track blok._uid) {
						<div class="flex">
							@if (titleComponents) {
								<ndc-dynamic
									[ndcDynamicComponent]="
										titleComponents[blok['component']]
									"
									[ndcDynamicInputs]="$any(blok)"
									class="hidden"
								/>
							}
						</div>
					}
					@for (blok of contentInputs(); track blok['_uid']) {
						<div class="flex">
							@if (richTextComponents) {
								<ndc-dynamic
									[ndcDynamicComponent]="
										richTextComponents[blok['component']]
									"
									[ndcDynamicInputs]="blok"
								/>
							}
						</div>
					}
					<vp-filter-heading
						[indicator]="activeFilterCount()"
						[numberOfResults]="numberOfResults()"
						[sortOptions]="sortOptions()"
						[title]="
							(numberOfResults() === 0 || numberOfResults() > 1
								? `storyblok.pages.filterable-list.${type()}-title-plural`
								: `storyblok.pages.filterable-list.${type()}-title-singular`
							) | translate: { amount: numberOfResults() }
						"
						(sortChanged)="sortOption.set($event)"
					>
						<div data-test-id="mobile">
							<ng-container [ngTemplateOutlet]="filtersTpl" />
						</div>
					</vp-filter-heading>
					@if (activeScenario() === 'vdc-hotels') {
						<sb-filterable-list-vdc-hotels
							[baseUrl]="baseUrl()"
							[business]="valkBusiness()"
							[showPrices]="showPrices()"
							[sortOption]="sortOption()"
						/>
					} @else if (activeScenario() === 'vdc-packages') {
						<sb-filterable-list-vdc-packages
							[baseUrl]="baseUrl()"
							[showPrices]="showPrices()"
							[sortOption]="sortOption()"
						/>
					} @else if (activeScenario() === 'vdcvhi-hotels') {
						<sb-filterable-list-vdcvhi-hotels
							[baseUrl]="baseUrl()"
							[showPrices]="showPrices()"
							[sortOption]="sortOption()"
						/>
					}
				</div>
			</div>
		</div>
	</section>
	@for (blok of subContentInput(); track $index) {
		@if (subContentComponents) {
			<ndc-dynamic
				[ndcDynamicComponent]="subContentComponents[blok['component']]"
				[ndcDynamicInputs]="blok"
			/>
		}
	}
</div>

<ng-template #filtersTpl>
	<vp-filters
		[activeFilters]="filterableListService.filters()"
		[filters]="filters()"
		[searchLoading]="locationSearch.loading()"
		[searchOptions]="locationSearch.options()"
		(activeFiltersChange)="filterableListService.filters.set($event)"
		(searchSelected)="locationSearch.onSelected($event)"
		(searched)="locationSearch.onSearched($event)"
	/>
</ng-template>
